// src/api/AxiosInstance.js
import axios from "axios";
import DefaultData from '../../CompanyData/DefaultData'
import config from "./APIConfig";

const axiosInstance = axios.create({
  baseURL: DefaultData.APIACTIVEURL,
});

// Add access token to each request
axiosInstance.interceptors.request.use((config) => {
  const tenantId = DefaultData?.TENANTID;
  if (tenantId) {
    config.headers["X-Tenant-ID"] = tenantId;
  }
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// Auto-refresh token on 401
axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    // Only retry once
    if (err.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const response = await axios.post(
          config.APIACTIVEURL + "auth/refresh",
          { refreshToken }
        );

        const { accessToken, refreshToken: newRefreshToken } = response.data;

        // Store new tokens
        setTokens({ accessToken, refreshToken: newRefreshToken });

        // Update and retry original request
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshErr) {
        console.error("Token refresh failed:", refreshErr);

        // Clear tokens and optionally redirect
        clearTokens();
        // window.location.href = "/login"; // ← Uncomment to auto-redirect on failure
      }
    }

    return Promise.reject(err);
  }
);

// 🔐 Set both tokens in localStorage
export const setTokens = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem("accessToken", accessToken);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
};

// 🔐 Remove tokens
export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export default axiosInstance;